import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SendTextMessage as SendTextMessageMutation,
    SendTextMessageVariables as SendTextMessageMutationVariables,
    TextMessageSendInput,
} from 'nutshell-graphql-types';

import SEND_TEXT_MESSAGE from '../mutations/send-text-message.graphql';

export const useSendTextMessage = (): {
    sendTextMessage: (input: TextMessageSendInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [sendTextMessage, {loading, error}] = useMutation<
        SendTextMessageMutation,
        SendTextMessageMutationVariables
    >(SEND_TEXT_MESSAGE);

    return {
        sendTextMessage: (input: TextMessageSendInput) => {
            return sendTextMessage({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
